import React, { useEffect, useRef } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import MissionDirector from "../../../components/userThumbnail/missionDirector";
import FilterDropdown from "./FilterDropdown";
import ShowMore from "../../../shared/commonComponents/ShowMore";

const MissionDirectors = (props) => {
  const filterRef = useRef();
  // const [isStricky, setStricky] = React.useState(false);

  const [offeringValue, setOfferingValue] = React.useState("Offering");
  const [industryValue, setIndustryValue] = React.useState("Industry");
  const [locationValue, setLocationValue] = React.useState("Geography");
  const [coachList, setCoachList] = React.useState([]);
  const [isClearDisable, setIsClearDisable] = React.useState(true);
  const [searchResultCount, setSearchResultCount] = React.useState(50);
  useEffect(() => {
    setCoachList(props.coachList);
  }, [props.coachList]);

  const filterDirectors = () => {
    let filter = {};

    if (
      offeringValue &&
      offeringValue !== "All" &&
      offeringValue !== "Offering"
    ) {
      filter.offering = offeringValue;
    }
    if (
      industryValue &&
      industryValue !== "All" &&
      industryValue !== "Industry"
    ) {
      filter.industry = industryValue;
    }
    if (
      locationValue &&
      locationValue !== "All" &&
      locationValue !== "Geography"
    ) {
      filter.geography = locationValue;
    }

    let filteredList = props.coachList.filter((item) => {
      for (var key in filter) {
        if (item[key] === undefined || item[key] != filter[key]) return false;
      }
      return true;
    });

    setCoachList(filteredList);
  };

  const resetDirectors = () => {
    if (isClearDisable) {
      return;
    }
    setOfferingValue("Offering");
    setIndustryValue("Industry");
    setLocationValue("Geography");
    setCoachList(props.coachList);
    setIsClearDisable(true);
  };

  useEffect(() => {
    if (offeringValue !== "Offering") {
      console.log(offeringValue);
      setIsClearDisable(false);
    }
    if (industryValue !== "Industry") {
      setIsClearDisable(false);
      console.log(industryValue);
    }
    if (locationValue !== "Geography") {
      setIsClearDisable(false);
      console.log(locationValue);
    }
  }, [offeringValue, industryValue, locationValue]);
  // const callbackFunction = (entries) => {
  //     const [entry] = entries
  //     setStricky(entry.isIntersecting)
  // }
  // const options = {
  //     root: null,
  //     rootMargin: "10px",
  //     threshold: 1.0
  // }

  // useEffect(() => {

  //     const observer = new IntersectionObserver(callbackFunction, options)
  //     console.log(observer)
  //     if (filterRef.current) observer.observe(filterRef.current)

  //     return () => {
  //         if (filterRef.current) observer.unobserve(filterRef.current)
  //     }
  // }, [filterRef, options])

  return (
    <Modal
      show={props.show}
      fullscreen={true}
      onHide={() => props.onClose(false)}
      dialogClassName="mission-director-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={false}

    // className="missionDirectorModal"
    >
      <Modal.Body>
        <div className="header mb-5 p-0">
          <div className="logo-image" />
        </div>
        <div className="md-content-wrapper">
          <div
            className="close directors-close"
            onClick={() => props.onClose(false)}
          />
          <div className="md-content">
            {/* <div className='content-header'>
                            <div className="title">Chief Of Staff (Dean)</div>
                        </div> */}
            <div className="content-body">
              <div className="content-header">
                <div className="title">Chief Of Staff (Dean)</div>
              </div>
              <div className="dean-row">
                {props.deanData && (
                  <>
                    <MissionDirector
                      class=" big-profile white-border"
                      deanClass="pointer-event-none"
                      user={{ ...props.deanData }}
                      imgClass="dean-avatar"
                    />
                    <div className="dean-desc" dangerouslySetInnerHTML={{ __html: props.deanData.deanBrief }}></div>
                  </>
                )}
              </div>
              <div className="dean-line"></div>

              <div className="mission-director-filters" ref={filterRef}>
                <div className="title m-0">Mission Directors</div>

                <div className="filters">
                  <FilterDropdown
                    label="Offering"
                    value={offeringValue}
                    onChange={(value) => setOfferingValue(value)}
                    options={props.offeringList}
                  />
                  <div className="v-devider" />
                  <FilterDropdown
                    label="Industry"
                    value={industryValue}
                    onChange={(value) => setIndustryValue(value)}
                    options={props.industryList}
                  />
                  <div className="v-devider" />
                  <FilterDropdown
                    label="Geography"
                    value={locationValue}
                    onChange={(value) => setLocationValue(value)}
                    options={props.geographyList}
                  />
                </div>

                <div className="dean-search-wrapper">
                  <button
                    className="cdx-btn dean-search"
                    onClick={filterDirectors}
                  >
                    <img
                      src="./space/img/Lens.svg"
                      alt="test"
                      className="me-2"
                      height={18}
                    />
                    Search
                  </button>
                  <button
                    className={
                      isClearDisable
                        ? "cdx-btn dean-search disabled"
                        : "cdx-btn dean-search"
                    }
                    onClick={resetDirectors}
                  >
                    Clear
                  </button>
                </div>
              </div>

              <div className="mission-director-table">
                <Row className="m-0 w-100">
                  {coachList && coachList.length > 0 ?
                    coachList.slice(0, searchResultCount).map((item, index) => {
                      return (
                        <Col key={`wrtik${index}`} sm={3} className="mb-5 p-0">
                          <MissionDirector
                            class=" small-profile white-border"
                            user={item}
                            offeringId={props.offeringId}
                            imgClass="mission-director-avatar"
                          />
                        </Col>
                      );
                    })
                    :
                    <div className="nodata-mission-director">No Data Available</div>
                  }

                  {coachList.length > searchResultCount && (
                    <ShowMore
                      onClick={() => {
                        setSearchResultCount(searchResultCount + 50);
                      }}
                    />
                  )}
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MissionDirectors;
